import { useCheckFeatureFlag } from './useFeatureFlags';
import { FeatureFlags } from './useFeatureFlags/types';

function useWebsocketGrpcMetricsEnabled() {
  const checkFeatureFlag = useCheckFeatureFlag();

  return checkFeatureFlag(FeatureFlags.ORG_ENABLE_WEBSOCKET_GRPC_METRICS);
}

export default useWebsocketGrpcMetricsEnabled;
